import React from "react";
import ReactSVG from "react-svg";
import { Link } from "gatsby";
import moment from "moment";
import { Thumbnail, ShareButton } from "..";
import clockImg from "../../images/clock.svg";
import { generatePageUrl } from "../../core/utils";

moment.locale("pl");

export const SensitiveQuestionsTileMobile: React.FC<any> = ({
  slug,
  author,
  title,
  publicationDate,
  readingTime,
  thumbnail,
  thumbnail2x,
}) => {
  return (
    <Link
      to={generatePageUrl(slug)}
      className="flex py-2.5 justify-between space-x-6"
    >
      <div className="flex flex-col justify-between flex-grow">
        <div>
          <div className="w-16 h-0.5 rounded-sm bg-blue-10 mb-2" />
          <h3 className="text-s font-bold text-black">{title}</h3>
        </div>
        <div className="flex justify-between items-center text-grey-5 text-xxs">
          <div className="flex space-x-2">
            <span>{moment(publicationDate).format("D MMM")}</span>
            <div className="flex space-x-1">
              <ReactSVG path={clockImg} />
              <span>{readingTime} min</span>
            </div>
          </div>
          <ShareButton path={slug} />
        </div>
      </div>
      <div className="w-20 h-20 flex-shrink-0 overflow-hidden">
        <Thumbnail source={{ thumbnail, thumbnail2x }} />
      </div>
    </Link>
  );
};
